import React from 'react';
import { OPERATIONS } from '@/lib/operations';
import * as Icons from 'lucide-react';
import { IDS } from '@/constants/testIds/wizard';

export const OperationSidebar = ({ op, setOp }) => {
  return (
    <div className="border-b border-border/70" data-testid={IDS.left.operationList}>
      <div className="panel-header">
        <div className="flex items-center gap-2">
          <Icons.Cog className="h-4 w-4 text-primary" />
          <span className="panel-title">Muveletek</span>
        </div>
        <span className="text-xs text-muted-foreground">{OPERATIONS.length} db</span>
      </div>
      <div className="max-h-[240px] overflow-y-auto p-2 grid grid-cols-2 gap-1">
        {OPERATIONS.map(o => {
          const Icon = Icons[o.icon] || Icons.Wrench;
          const active = o.id === op;
          return (
            <button
              key={o.id}
              type="button"
              className={`op-item ${active ? 'op-item-active' : ''}`}
              onClick={() => setOp(o.id)}
              data-testid={IDS.left.operationItem(o.id)}
            >
              <Icon className={`h-4 w-4 mt-0.5 ${active ? 'text-primary' : 'text-muted-foreground'}`} />
              <div className="flex flex-col text-left">
                <span className="text-xs font-medium">{o.name}</span>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default OperationSidebar;
